import defineMessages from "../../../../../../common/helpers/defineMessages";

const messages = defineMessages({
    deleteAudio: {
        id: "general.deleteAudio",
    },
    uploadAudio: {
        id: "general.uploadAudio",
    },
    fileUpload: {
        id: "general.fileUpload",
    },
    fileTooLarge: {
        id: "general.fileTooLarge",
    },
    fileIncorrectFormat: {
        id: "general.fileIncorrectFormat",
    },
    uploadMp3: {
        id: "general.uploadMp3",
    },
    fileSizeLimit: {
        id: "general.fileSizeLimit",
    },
    close: {
        id: "general.close",
    },
    uploadAudioInProgress: {
        id: "general.uploadAudio.inProgress",
    },
});

export default messages;
